import Layout from './Layout'

export {
  Inner,
  ColumnGrid,
  MobileHideWrapper,
  DesktopHideWrapper,
} from './styledComponents'
export default Layout
